import { useState } from "react";

const stores = [
  {
    id: 1,
    tag: "Loja I",
    name: "Maverick",
    unit: "Motors",
    address: ["Av. do Estado, 1400", "Fundação — São Caetano do Sul, SP"],
    href: "https://maverickmotors.com.br/",
    dark: true,
  },
  {
    id: 2,
    tag: "Loja II",
    name: "Maverick",
    unit: "Motors II",
    address: ["Rua Marechal Deodoro, 2785", "Centro — São Bernardo do Campo, SP"],
    href: "https://maverickmotors2.com.br/",
    dark: false,
  },
];

function StoreCard({ store }) {
  const [hovered, setHovered] = useState(false);

  const base = store.dark
    ? "bg-[#111] border-[#222] text-white"
    : "bg-[#f5f5f0] border-[#e0e0da] text-[#111]";

  const tagColor = store.dark ? "text-[#fff]" : "text-[#000]";
  const subtitleColor = store.dark ? "text-[#fff]" : "text-[#000]";
  const addressColor = store.dark ? "text-[#fff]" : "text-[#000]";
  const dividerColor = store.dark ? "border-[#222]" : "border-[#e0e0da]";
  const ctaColor = store.dark ? "text-white" : "text-[#111]";
  const arrowColor = store.dark ? "text-white" : "text-[#111]";

  return (
    <a
      href={store.href}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={`
        flex-1 border relative overflow-hidden no-underline block
        transition-all duration-300 ease-out
        ${base}
        ${hovered ? "border-[#555] -translate-y-1" : ""}
      `}
      style={{ textDecoration: "none" }}
    >
      {/* Overlay shimmer */}
      <div
        className={`absolute inset-0 pointer-events-none transition-opacity duration-300 ${hovered ? "opacity-100" : "opacity-0"}`}
        style={{
          background: store.dark
            ? "linear-gradient(135deg, rgba(255,255,255,0.04) 0%, transparent 60%)"
            : "linear-gradient(135deg, rgba(0,0,0,0.04) 0%, transparent 60%)",
        }}
      />

      <div className="relative p-8 flex flex-col justify-between min-h-[220px]">
        <div>
          <p className={`text-[9px] font-semibold tracking-[4px] uppercase mb-4 ${tagColor}`}>
            {store.tag}
          </p>

          <p
            className="text-[28px] font-light leading-tight"
            style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: "2px" }}
          >
            {store.name}
            <br />
            {store.unit}
          </p>

          <p
            className={`text-[13px] font-light mt-1 ${subtitleColor}`}
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            {store.subtitle}
          </p>

          <div className={`mt-5 text-[10px] tracking-[1.5px] uppercase leading-[1.8] ${addressColor}`}>
            {store.address.map((line, i) => (
              <p key={i}>{line}</p>
            ))}
          </div>
        </div>

        <div className={`flex items-center justify-between mt-6 pt-5 border-t ${dividerColor}`}>
          <span className={`text-[10px] font-semibold tracking-[3px] uppercase ${ctaColor}`}>
            Acessar
          </span>
          <span
            className={`text-base transition-all duration-300 ${arrowColor} ${hovered ? "translate-x-1 opacity-100" : "opacity-50"}`}
          >
            →
          </span>
        </div>
      </div>
    </a>
  );
}

export default function HomePage() {
  return (
    <div
      className="min-h-screen bg-[#0a0a0a] flex flex-col items-center justify-center px-6 py-16 relative overflow-hidden"
    >
      {/* Grid background */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />

      {/* Header */}
      <div
        className="text-center mb-14 relative"
        style={{ animation: "fadeDown 0.9s cubic-bezier(0.22, 1, 0.36, 1) both" }}
      >
        <h1
          className="text-white font-light leading-none"
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: "clamp(36px, 7vw, 58px)",
            letterSpacing: "12px",
            textTransform: "uppercase",
          }}
        >
          Maverick
        </h1>
        <p className="text-[#888] text-[11px] font-medium tracking-[8px] uppercase mt-3">
          Motors
        </p>
        <div className="w-14 h-px bg-[#333] mx-auto my-5" />
        <p
          className="text-[#fff] text-[15px] font-light italic tracking-[3px]"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Selecione sua loja
        </p>
      </div>

      {/* Cards */}
      <div
        className="flex flex-col sm:flex-row gap-6 w-full max-w-2xl"
        style={{ animation: "fadeUp 0.9s 0.25s cubic-bezier(0.22, 1, 0.36, 1) both", animationFillMode: "both" }}
      >
        {stores.map((store) => (
          <StoreCard key={store.id} store={store} />
        ))}
      </div>

      {/* Footer */}
      <div
        className="mt-12 text-center"
        style={{ animation: "fadeUp 0.9s 0.45s cubic-bezier(0.22, 1, 0.36, 1) both", animationFillMode: "both" }}
      >
        <p className="text-[#fff] text-[10px] tracking-[3px] uppercase">
          Grupo Maverick · Excelência em veículos
        </p>
      </div>

      {/* Keyframes via style tag */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;600&family=Montserrat:wght@300;400;500;600&display=swap');
        @keyframes fadeDown {
          from { opacity: 0; transform: translateY(-24px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}